import {React, useState, useEffect } from "react";
import { FxmsData } from "../../fxms/datas/FxData";
import { FxWindow } from "./../../fxms/windows/FxWindows";
import {
  getMonth,
  getMonthBetween
} from "../common/commonMethod";
import MuiTable from "../common/MuiTable";
import { UI_6_1_tableRow } from "./UI_6_1.helper";
import { getInloInfo } from "../common/commonMethod";

/* 에너지거래 > 거래실적 */
export const UI_6_1 = (props) => {
  const user = FxmsData.getUser();
  const inlo = getInloInfo(FxmsData.getInlo(user.inloNo),user);
  const [fetchData, setFetchData] = useState([]);
  const [tableRenderKey, setTableRenderKey] = useState(0);
  const [fetchComplexInlo, setFetchComplexInlo] = useState([]);
  const [selected, setSelected] = useState({
    complexInloNo: user.ugrpNo === 1021||user.ugrpNo === 1024? inlo.complexInloNo : "",
    energy: "",
    startDate: getMonth(-3),
    endDate:  getMonth(-1)
  });
  const [energyLabel, setEnergyLabel] = useState('');

  const energyOptions = [
    { label: "압축공기", value: "AIR" },
    { label: "스팀", value: "STEAM" }
  ];

  const dataGrid = (
    transNo,                // 번호
    energy,                 // 에너지종류
    complexName,            // 산단명    
    sourcePlant,            // SOURCE공장 (매도공장)
    sinkPlant,              // SINK공장 (매수공장)
    transDate,              // 거래체결일
    transPeriod,            // 거래기간
    monthCntrtTrnsVol,      // 월계약거래량
    hourlyMaxCntrtTrnsVol,  // 시간당 최대계약거래량
    trnsStCd,               // 거래상태
    trnsMethdCd,            // 거래방식
    trnsChrg,               // 거래단가
    trnsDescr,              // 거래설명
  ) => {
    return {
      transNo,
      energy,
      complexName,      
      sourcePlant,
      sinkPlant,
      transDate,
      transPeriod,
      monthCntrtTrnsVol,
      hourlyMaxCntrtTrnsVol,
      trnsStCd,
      trnsMethdCd,
      trnsChrg,
      trnsDescr,
    }
  }


  const resultRow = fetchData.map(item => {
    return dataGrid(
      item.trnsNo,
      item.engDescr,
      item.complexInloName,
      item.sellInloName,
      item.buyInloName,      
      item.trnsDtm ? item.trnsDtm : '-',
      item.trnsPeriod ? item.trnsPeriod : '-',
      item.monthCntrtTrnsVol ?  new Intl.NumberFormat("ko-KR").format(item.monthCntrtTrnsVol) : '-',
      item.hourlyMaxCntrtTrnsVol ? new Intl.NumberFormat("ko-KR").format(item.hourlyMaxCntrtTrnsVol) : '-',
      item.trnsStCd,
      item.trnsMethdCd,
      item.trnsChrg ? new Intl.NumberFormat("ko-KR").format(item.trnsChrg) : '-',
      item.trnsDescr ? item.trnsDescr : '-'
    )
  })


  useEffect(() => {
    console.log("selected ........ ", selected);
  }, [selected])

  useEffect(() => {
    getComplexInloData();
    submitBtnClick();
  }, []);

  useEffect(() => {
    const option = energyOptions.find(option => option.value === selected.energy);
    if (option) {
      setEnergyLabel(option.label);
    }
  }, [selected.energy])

  const getComplexInloData = async () => {
    const uri = "vup/getComplexInloList"
    try {
      const res = await FxmsData.GET(uri);
      if(user.inloClCd === "PROJECT") {
        setFetchComplexInlo(res.data);
      } else {
        setFetchComplexInlo(res.data[0]);
        setSelected((prev) => {
          return { ...prev, complexInloNo: res.data[0].inloNo };
        })
      }
      console.log("complex List >> ", res.data);
    } catch (e) {
      console.log("getComplexInloList error ........", e);
    }
  }

  const handleSelectData = (event) => {
    const {value, name } = event.target;
    setSelected((prev) => {
      return { ...prev, [name]: value };
    })
  }

  const submitBtnClick = async () => {

    if (selected == null) return;

    if (parseInt(selected.startDate) > parseInt(selected.endDate)) {
      FxWindow.alert("조회 기간이 잘못되었습니다.", true);
      return;
    } else if (getMonthBetween(selected.startDate.replace(/-/gi, ""), selected.endDate.replace(/-/gi, "")) > 3*12) {
      FxWindow.alert("최대 3년까지 조회 가능합니다.", true);      
      return;
    }

    const param = {
      energy: selected.energy,
      complexInloNo: selected.complexInloNo,
      startDate: selected.startDate.replace(/-/gi, ""),
      endDate: selected.endDate.replace(/-/gi, ""),
    }
    try {
      // 조회 시 페이지를 1페이지로 초기화하기 위해 테이블 리마운트
      setTableRenderKey((prev) => prev + 1);
      const uri = "vup/select_6_1";
      const res = await FxmsData.GET(uri, param);
      console.log("UI_6_1 res........", res.data);

      FxWindow.alert(res.data.length + " 건의 데이터가 조회되었습니다.");
            
      setFetchData(res.data);
    } catch (e) {
      console.log("UI_6_1 fetchData error", e);
    }
  }



  return (
    <>
    <div className="predict">
      <div className="FxCrudFilter">
        <div className="FxFilterLeft">
          <label className="FxLabelSearch"></label>
          <select className="FxSelectSearch" name="energy" onChange={handleSelectData}>            
            {energyOptions.map((item, index) => (
              <option key={index} value={item.value} name="energy">{item.label}</option>
            ))}
          </select>
          <label className="FxLabelSearch"></label>
          <select className="FxSelectSearch" onChange={handleSelectData} name="complexInloNo">
            {user.inloClCd === "PROJECT" ?
              <>
                <option value="">산업단지 전체</option>
                {fetchComplexInlo.map((item) => (
                  <option key={item.inloNo} value={item.inloNo} name="complexInloNo">
                    {item.inloName}
                  </option>
                ))}
              </>
            :
              <option value={fetchComplexInlo.inloNo}> {fetchComplexInlo.inloName} </option>
            }
          </select>
        </div>
        <div className="FxFilterRight">
          <input className="FxDate" type="month" name="startDate"value={selected.startDate} onChange={handleSelectData} />
          <label className="FxLabelSearch">~</label>
          <input className="FxDate" type="month" name="endDate" value={selected.endDate} onChange={handleSelectData} />
          <input className="FxButtonSearch" type="button" value="조회" onClick={submitBtnClick}/>
        </div>
      </div>
      <div className="FxCrudDataGrid">
        {selected.energy ?
          <div class="FxDataTitle">
            {energyLabel} 거래내역
          </div>
        :
        null}
        <div class="FxMuiTable">
          <MuiTable
            key={tableRenderKey}
            tableRowDataList={UI_6_1_tableRow}
            rows={resultRow}
            menuFullName ={props.menuFullName}           
          />
        </div>
      </div>
    </div>
    </>
  )
}
